import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppRegistrationYubleSelectionPage } from './app-registration-yuble-selection';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppRegistrationYubleSelectionPage,
  ],
  imports: [
    IonicPageModule.forChild(AppRegistrationYubleSelectionPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppRegistrationYubleSelectionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-registration-yuble-selection/app-registration-yuble-selection.module.ts